const getProactiveVoice = baseId => ({
  id: 'proactive-voice',
  version: 1,
  name: 'Proactive Voice Campaign',
  description: 'Proactive Voice',
  rootNodeId: `${baseId}proactiveVoice`,
  comment: 'template',
  nodes: [
    {
      type: 'IVR_NODE_DIAL',
      ivrNode: {
        id: `${baseId}dial`,
        name: 'Dial',
        description: 'Dial',
        number: '',
        selection: '_dial',
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}hangUp`,
        name: 'Hang up',
        message: {
          type: 'TEXT',
          message: 'Thank you for your time. Goodbye.',
        },
        nextId: '',
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}voicemailMessage`,
        name: 'Voicemail Message',
        description: 'Voicemail Message',
        message: {
          message:
            'A voicemail message can be left if Gladly detects that a voicemail picked up the proactive phone call.',
          type: 'TEXT',
          language: 'en-US',
          voice: '',
        },
        nextId: `${baseId}hangUp`,
      },
    },
    {
      type: 'IVR_NODE_VARIABLE_MATCH',
      ivrNode: {
        id: `${baseId}proactiveVoice`,
        name: 'Voicemail Detection',
        description: 'my new node',
        variableMatches: [
          {
            expression: '{{._answeredBy}}',
            pattern: '/machine_end_beep/',
            nextId: `${baseId}voicemailMessage`,
          },
        ],
        defaultNextId: `${baseId}greeting`,
        errorNodeId: `${baseId}greeting`,
      },
    },
    {
      type: 'IVR_NODE_MESSAGE',
      ivrNode: {
        id: `${baseId}greeting`,
        name: 'Greeting',
        description: 'Greeting',
        message: {
          message:
            'A message can be played when a customer, not a voicemail, actually picks up the proactive voice call.',
          type: 'TEXT',
          language: '',
          voice: '',
        },
        nextId: `${baseId}menu`,
      },
    },
    {
      type: 'IVR_NODE_MENU',
      ivrNode: {
        id: `${baseId}menu`,
        name: 'Menu',
        description: 'Menu',
        message: {
          message: 'To speak with an agent, please press 1',
          type: 'TEXT',
          language: '',
          voice: '',
        },
        menu: [
          {
            dtmf: '1',
            speech: '',
            nextId: `${baseId}dial`,
          },
        ],
        language: 'en-US',
        speechTimeout: 5000000000,
        badSelectionNodeId: `${baseId}hangUp`,
      },
    },
  ],
  debug: false,
});

export default getProactiveVoice;
